import K from '../constants';
import restHelpers from '../helpers/restHelper';

const getSubscriptionsFn = uuid => restHelpers.withBearer.get(`${K.API_URL}/users/${uuid}/subscriptions?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});
const createDisconnectionFn = (uuid, subscriptionId) => restHelpers.withBearer.post(`${K.API_URL}/users/${uuid}/subscriptions/${subscriptionId}/disconnect`, {});
const removeDisconnectionFn = (uuid, subscriptionId) => restHelpers.withBearer.delete(`${K.API_URL}/users/${uuid}/subscriptions/${subscriptionId}/disconnect`, {});
const downloadDocumentFn = url => restHelpers.withBearer.post(`${K.API_URL}/download-document`, { data: { url }});

export default {
    getSubscriptions: getSubscriptionsFn,
    createDisconnection: createDisconnectionFn,
    removeDisconnection: removeDisconnectionFn,
    downloadDocument: downloadDocumentFn
}



// WEBPACK FOOTER //
// ./src/services/subscriptions.js